import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss']
})
export class InputComponent implements OnInit, OnChanges {
  @Input()
  title: string;

  @Input()
  inputType: string; 
  
  @Input()
  info?: string;

  @Input()
  width: string;

  @Input()
  titleSize: string;

  @Input()
  disabled:boolean = false

  @Input()
  value: string = '';

  hasInfo: boolean = false;

  @Output() 
  valueChange = new EventEmitter<string>();

  color: string = '';
  language: string;

  colorMap = {
    'pt': {
      'Não atende': '#FAC300',
      'Atende parcialmente': '#84C2FB',
      'Atende plenamente': '#FB84F9',
      'Supera': '#62FFA1',
      'Acima': '#62FFA1',
    },
   'es': {
      'No atiende': '#FAC300',
      'Cumple parcialmente': '#84C2FB',
      'Cumple plenamente': '#FB84F9',
      'Supera': '#62FFA1',
      'Acima': '#62FFA1',
    },
  };

  ngOnInit(): void {
    this.checkInfo()
  }

  checkInfo() {
    if(this.info) {
      this.hasInfo = true;

      this.handleColor(this.info)
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.info) {
      this.handleColor(changes.info.currentValue);
    }
  }

  onInputChange(value: string): void {
    this.valueChange.emit(value);
  }

  handleColor(value: string){
    this.language = localStorage.getItem('culture')
    const formatLanguage = this.language?.split('-')[0]

    this.color = this.colorMap[formatLanguage][value];
  }
}
